import Vue from "vue";
import { Ability, AbilityBuilder } from "@casl/ability";
import { abilitiesPlugin } from "@casl/vue";

/**
 * Defines how to detect object's type: https://stalniy.github.io/casl/abilities/2017/07/20/define-abilities.html
 */
export const ability = new Ability([]);

function subjectName(item) {
  if (!item || typeof item === "string") {
    return item;
  }

  return item.__type;
}

export function defineRulesFor(user) {
  const { can, cannot, rules } = new AbilityBuilder();
  //can(...)
  //cannot(...)

  return new Ability(rules);
}

Vue.use(abilitiesPlugin, ability);

export default ability;
